export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.432 9.678a1 1 0 011.209.053l6 5A1.001 1.001 0 0118 16.5H6a1 1 0 01-.64-1.769l6-5 .072-.053zM8.762 14.5h6.475L12 11.802 8.763 14.5z\" fill=\"#7B61FF\"/><path d=\"M7 7.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-19a1 1 0 01-1-1v-15a1 1 0 011-1h19zm-18 15h17v-13h-17v13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};